// Pure lead-form helpers; this module contains no secrets and can be tested in Node.
export function normalizeAustralianMobile(phone) {
  const digits = String(phone || '').replace(/[\s().-]/g, '');
  if (/^04\d{8}$/.test(digits)) return '+61' + digits.slice(1);
  if (/^614\d{8}$/.test(digits)) return '+' + digits;
  if (/^\+614\d{8}$/.test(digits)) return digits;
  return '';
}
export function isValidContactPhone(phone) {
  return !String(phone || '').trim() || /^\+?[\d\s().-]{8,25}$/.test(String(phone).trim());
}